export const homePagePath = '/'
export const termsIframeWidth = '800'
export const termsIframeHeight = '600'
export const homeRowId = 'HOME'
export const homeInitialRowIndex = '0'
export const homeRowsCount = 30
export const ZERO_ROW = 'zero row'
